/**
 * Created by Richie on 2017/8/2.
 */
import React from 'react';
import moment from 'moment';
import { message, DatePicker } from 'antd';

const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker


class DateRange extends React.Component {
  state = {
    startValue: this.props.defaultValueBegin,
    endValue: this.props.defaultValueEnd,
    next:'',
    endOpen: false,
  };

  disabledStartDate = (startValue) => {
    const endValue = this.state.endValue;
    if (!startValue || !endValue) {
      return false;
    }
    return startValue.valueOf() > endValue.valueOf();
  }

  disabledEndDate = (endValue) => {
    const startValue = this.state.startValue;
    let k2 = moment(startValue)
    if (!endValue || !startValue) {
      return false;
    }
    return ( endValue.valueOf() > k2.add(11,'M').valueOf()  );
    
  }

  onChange = (field, value) => {
    this.setState({ [field]: value });
  }

  onStartChange = (value) => {
    const { endValue } = this.state;
    const newEndValue = moment(value).add(11, 'M');
    const isReset = newEndValue.valueOf() < endValue.valueOf();
    this.setState({
      startValue: value,
      endValue: isReset ? newEndValue : endValue,
    }, () => {
      const { startValue, endValue } = this.state
      this.props.loadData(this.props.params,{begin:startValue.format(monthFormat),end:endValue.format(monthFormat)});
    });
    if(!value){
      this.props.clearStartDate ? this.props.clearStartDate(): null
    }
    
  }

  onEndChange = (value) => {
    this.setState({
      endValue: value,
    }, () => {
      const { startValue ,endValue } = this.state
      if(startValue && endValue){
        this.props.loadData(this.props.params,{begin:startValue.format(monthFormat),end:endValue.format(monthFormat)})      
      }else{
        message.warning('请选择日期！')
      }
    });
    if(!value){
      this.props.clearEndDate ? this.props.clearEndDate() :null
    }    
  }

  handleStartOpenChange = (open) => {
    if (!open) {
      this.setState({ endOpen: true });      
    }
  }

  handleEndOpenChange = (open) => {
    this.setState({ endOpen: open });

  }

  componentWillReceiveProps(nextProps){
    if(this.state.next != nextProps.next){
      this.setState({
        startValue:moment().add(-11,'M'),
        endValue:moment(),
        next:nextProps.next,
      })
    }    
  }

  render() {
    const { startValue, endValue, endOpen } = this.state;
    const { disabledDate } = this.props;
    return (
      <span style={this.props.style}>
        <MonthPicker
          disabledDate={disabledDate ? disabledDate : this.disabledStartDate}
          allowClear={false}
          format={monthFormat}
          value={startValue}
          placeholder="选择开始月份"
          onChange={this.onStartChange}
          style={{ verticalAlign: 'middle' }}
          onOpenChange={this.handleStartOpenChange}
        />
        <span className="ant-divider" />
        <MonthPicker
          disabledDate={disabledDate ? disabledDate : this.disabledEndDate}
          allowClear={false}
          format={monthFormat}
          value={endValue}
          placeholder="结束月份"
          onChange={this.onEndChange}
          open={endOpen}
          style={{ verticalAlign: 'middle' }}
          onOpenChange={this.handleEndOpenChange}
        />
      </span>
    );
  }
}
export default DateRange;


// WEBPACK FOOTER //
// ./src/components/common/DateRange.js